import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from './../auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthRoutes } from 'src/app/utilities/routes';
import * as urls from '../../utilities/urls';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
  })
  export class ForgotPaswordComponent implements OnInit {

    forgotPasswordForm: UntypedFormGroup;
    buttonLoading = false;

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private authService: AuthService,
        private message: NzNotificationService,
        private httpClient: HttpClient,
        private notification: NzNotificationService

      ) {
        this.forgotPasswordForm = this.fb.group({
          email: ['', [ Validators.required]],
        });
      }
      ngOnInit() {

      }
      forgotPassword() {
          this.buttonLoading = true;
          if (this.forgotPasswordForm.valid) {
           const value = {
            email: this.forgotPasswordForm.value.email,
            terminal:  'merchant-board'
           };
           this.authService.forgetPassword(value).subscribe((response: any) => {
            this.notification.success(response.message, '', {
              nzKey : 'key'
            });
            this.buttonLoading = false;
            this.router.navigate([AuthRoutes.login]);
           }, err => {
             this.buttonLoading = false;
           });
          } else {
            this.buttonLoading = false;
            // tslint:disable-next-line: forin
            for (const i in this.forgotPasswordForm.controls) {
                this.forgotPasswordForm.controls[i].markAsDirty();
                this.forgotPasswordForm.controls[i].updateValueAndValidity();

            }
         }
      }

goToLogin() {
  this.router.navigate([AuthRoutes.login]);
}
arrayOfImgUrls = [
  'assets/slider/slider-1@2x.jpg',
  'assets/slider/slider-2@2x.jpg',
  'assets/slider/slider-3@2x.jpg',
  'assets/slider/slider-4@2x.jpg',
  
]
  }
